import { Leg } from "@dto/Direction";

/**
 * Calculate the distance of legs, and return a format that can be displayed.
 */
const formatDistanceForLegs = (
  legs: Leg[] | undefined,
): {
  distanceFormatted: string;
  unit: "mi" | "km" | "m" | "ft";
} => {
  let isMetric = false;

  const totalDistanceInMeters = (legs ?? []).reduce(
    (aggregate: number, item) => {
      // Directions API returns distance in metric or imperial based on the stops and if they are
      // in a country that uses metric. We will display the distance in the unit of the country.
      if (
        item.distance.text.endsWith(" km") ||
        item.distance.text.endsWith(" m")
      ) {
        isMetric = true;
      }
      return aggregate + item.distance.value;
    },
    0,
  );

  return formatDistance(totalDistanceInMeters, isMetric);
};

const formatDistance = (
  totalDistanceInMeters: number,
  isMetric: boolean = false,
): {
  distanceFormatted: string;
  unit: "mi" | "km" | "m" | "ft";
} => {
  if (totalDistanceInMeters === 0) {
    return { distanceFormatted: "0", unit: isMetric ? "m" : "ft" };
  }

  if (isMetric) {
    if (totalDistanceInMeters < 1000) {
      return {
        distanceFormatted: `${totalDistanceInMeters}`,
        unit: "m",
      };
    }

    return {
      distanceFormatted: (totalDistanceInMeters / 1000).toFixed(1),
      unit: "km",
    };
  }

  if (totalDistanceInMeters < 305) {
    return {
      distanceFormatted: `${Math.round(totalDistanceInMeters * 3.28084)}`,
      unit: "ft",
    };
  }

  return {
    distanceFormatted: (totalDistanceInMeters * 0.000621371).toFixed(1),
    unit: "mi",
  };
};

export { formatDistance, formatDistanceForLegs };
